export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";
// incr / decr product Qty
export const INCR_PRODUCT_QTY = "INCR_PRODUCT_QTY";
export const DECR_PRODUCT_QTY = "DECR_PRODUCT_QTY";
export const DELETE_PRODUCT_FROM_CART = "DELETE_PRODUCT_FROM_CART";
// PLACE An Order
export const PLACE_ORDER_REQUEST = "PLACE_ORDER_REQUEST";
export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAILURE = "PLACE_ORDER_FAILURE";
// CLEAR CART
export const CLEAR_CART_ITEMS = "CLEAR_CART_ITEMS";

// GET ALL ORDERS
export const GET_ALL_ORDERS_REQUEST = "GET_ALL_ORDERS_REQUEST";
export const GET_ALL_ORDERS_SUCCESS = "GET_ALL_ORDERS_SUCCESS";
export const GET_ALL_ORDERS_FAILURE = "GET_ALL_ORDERS_FAILURE";
